import {SizeType} from "antd/lib/config-provider/SizeContext";
export abstract class Constants {
    public static deletingReservationEmail: string = "tenutaricco@gmail.com"
    public static deletingReservationPhone: string = "+39 366 8248613"
    public static privacyManagerName: string = "Tenuta Ricco di De Luca Mara"
    public static privacyManagerAddressRow1: string = "Via Montale snc"
    public static privacyManagerAddressRow2: string = "73020 Cursi (LE) - Italia"
    public static privacyManagerPhone: string = "+39 366 8248613"
    public static privacyManagerEmail: string = "tenutaricco@gmail.com"
    public static privacyManagerVat: string = "05049000754"
    public static companyName: string = 'Tenuta Ricco'
    public static companyFullAddress: string = 'Via Montale 24 Cursi, Lecce - Italy'
    public static companyAddress: string = 'Via Montale 24'
    public static companyCity: string = 'Cursi, Lecce - Italy'
    public static companyPhone: string = '+39 366 8248613'
    public static companyEmail: string = "tenutaricco@gmail.com"
    public static companyVat: string = "IT05049000754"
    public static companyCin: string = "IT075025B400086796"
    public static companyCCIAA: string = "C.C.I.A.A. Lecce"
    public static mapsLink: string = "https://www.google.it/maps/dir/?api=1&destination=40.1580721,18.3101763"
    public static whatsappLink: string = "https://wa.me/393668248613?text=Messaggio%20a%20Tenuta%20Ricco%20%2D%20Salento%20http%3A%2F%2Fwww.tenutaricco%2Eit"
    public static facebookLink: string = "https://www.facebook.com/Tenuta-Ricco-Intour-1609423652603000"
    public static googlePlusLink: string = "https://g.page/r/CaGVRjzOSr_xEBA"
    public static instagramLink: string = "https://instagram.com/tenutaricco?igshid=YmMyMTA2M2Y="
    public static bookingLink: string = "https://www.booking.com/hotel/it/tenuta-ricco.it.html"
    public static airbnbLink: string = "https://www.airbnb.it/rooms/706332323735631867?adults=1&children=0&infants=0&check_in=2022-10-01&check_out=2022-10-06&federated_search_id=0128f919-ab42-4fd2-a4e2-2786c37cbfb1&source_impression_id=p3_1664182717_5jFnIH1q8I37Rb8F"
    public static tripadvisorLink: string = "https://www.tripadvisor.it/VacationRentalReview-g1048616-d24968992-Alloggio_1_Monolocale_con_angolo_cottura_e_vista_piscina-Cursi_Province_of_Lecce_Pug.html"
    public static googleHotelLink: string = "https://www.google.it/travel/hotels/entity/ChoIoaua4uPZ0t_xARoNL2cvMTFydmsxMnh4bhAB?gsas=1&rp=yAEB&ts=CAEaIAoCGgASGhIUCgcI6Q8QAhgZEgcI6Q8QAhgaGAEyAhAAKgQKABoA&ved=0CAAQ5JsGahcKEwj43IzlktyLAxUAAAAAHQAAAAAQBA&utm_campaign=sharing&utm_medium=link&utm_source=htls"
    public static happyRentalsLink: string = "https://www.happy.rentals/view/12095-tenuta-ricco-with-pool-and-garden"
    public static happyRentalLodging1Link: string = "https://www.happy.rentals/view/12095-tenuta-ricco-with-pool-and-garden"
    public static happyRentalLodging2Link: string = "https://www.happy.rentals/view/12092-tenuta-ricco-room-with-pool-and-garden"
    public static happyRentalLodging4Link: string = "https://www.happy.rentals/view/12094-tenuta-ricco-bilo-with-pool-and-garden"
    public static videoLink: string = "/assets/videos/video_ver1.mp4"
    public static gestioWS_baseURLString: string = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://sdi.execom.it'
    public static gestioWS_apikey: string = "r9vWQeLNIqt0X86By0o9FENKseBVOm2OnCUilWzlpOqD1PhX9kDq3c8MtSi7kKNh"
    public static largeScreenBreakpoint: number = 768
    public static userPrivacyPrefsKey: string = "userPrivacyPrefs"
    public static apiPrefix: string = '/api/v1'
    public static apiUrl: string = 'http://localhost:8080/api/v1'
    public static iconSize: string = '20px'
    public static componentsSize: SizeType = 'large'
    public static loginFormLayout: object = {
        wrapperCol: {
            xs: {offset: 4, span: 16},
            sm: {offset: 6, span: 12},
            md: {offset: 7, span: 10},
            lg: {offset: 8, span: 8},
            xl: {offset: 9, span: 6},
        }
    }
}